import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import Filters from './pages/Filters';
import SelecionarPerfil from './pages/SelecionarPerfil';
import SelecionarMonitores from './pages/SelecionarMonitores';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Home />} />
      <Route path="/filters" element={<Filters />} />
      <Route path="/selecionar-perfil" element={<SelecionarPerfil />} />
      <Route path="/selecionar-monitores" element={<SelecionarMonitores />} />
    </Routes>
  );
};

export default AppRoutes;